export default __webpack_public_path__ + "static/media/order_bagred.ad12a368.svg";